var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLens2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets/Glyphs/Product/Lens Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,0 L1.028125,2.34105263 C0.39375,2.94315789 0,3.77263158 0,4.68631579 C0,6.51789474 1.56625,8 3.5,8 C5.43375,8 7,6.51789474 7,4.68631579 C7,3.77263158 6.60625,2.94315789 5.971875,2.34105263 L3.5,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets/Glyphs/Product/Lens-Color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7151077,21.259374 C31.2738429,18.7689066 32.25,16.2782469 32.25,14.4383216 C32.25,10.8127739 29.894081,9 25.182243,9 C22.3395639,9 19.8280337,9 17.6476526,9 C14.3770809,9 7.25,11.3483661 7.25,18.3934646 C7.25,25.438563 9.93600321,31 16.8289829,31 C18.8382661,31 20.986481,30.0548425 23.0219014,28.5808489",
    id: "Path",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.500000, 27.000000) scale(-1, 1) translate(-28.500000, -27.000000) translate(25.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    stroke: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    mask: "url(#mask-2)",
    x: 3.5,
    y: 0,
    width: 4,
    height: 9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens2);
export default __webpack_public_path__ + "static/media/lens2.6c7874540c33e1083430b6e870053969.svg";
export { ForwardRef as ReactComponent };